import { render, staticRenderFns } from "./SubjectEditForm.vue?vue&type=template&id=04e83668"
import script from "./SubjectEditForm.vue?vue&type=script&lang=js"
export * from "./SubjectEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports